import React from 'react';
import isFunction from 'lodash/isFunction';
import { TableCell } from '@/components/common/ResponsiveTable';
import { renderHeaderName } from '../lib/dataListUtils';
import type Column from '../types/Column';
import type DataListTableCellProps from '../types/DataListTableCellProps';
import mapRenderProps from '../utils/mapRenderProps';

export type DataListTableBodyCellProps<DataType> = {
  TableCellProps?: DataListTableCellProps;
  column: Column<DataType>;
  row: DataType;
};

export default function DataListTableBodyCell<DataType>({
  TableCellProps,
  column: { align = 'left', headerName, mapProps, render },
  row,
}: DataListTableBodyCellProps<DataType>) {
  let child = null;
  const renderProps = React.useMemo(() => {
    if (mapProps) {
      return {
        ...row,
        ...mapRenderProps<DataType>(row, mapProps),
      };
    }

    return row;
  }, [row, mapProps]);

  if (
    (typeof render === 'string' || typeof render === 'undefined') &&
    typeof row[render as keyof DataType] !== 'undefined'
  ) {
    child = row[render as keyof DataType];
  } else if (isFunction(render)) {
    child = render(renderProps);
  }

  return (
    <TableCell
      label={renderHeaderName(headerName)}
      align={align}
      {...(TableCellProps && TableCellProps)}
    >
      {child as React.ReactNode}
    </TableCell>
  );
}
